const glConfig = window.$config||{};
export default glConfig;
